class GraphGenerator {
  constructor() {
    this.stageHeight = 460;
    this.stageWidth = 680;
    this.CANVAS_WIDTH = 177;
    this.CANVAS_HEIGHT = 120;

    this.cols = 22;
    this.rows = 15;

    this.STAGE_WIDTH = 680;
    this.STAGE_HEIGHT = 460;

    const FULL_HD_DOWNGRADE_FACTOR_X = 2.82;
    const FULL_HD_DOWNGRADE_FACTOR_Y = 2.34;

    this.xFix = this.CANVAS_WIDTH / this.STAGE_WIDTH;
    this.yFix = this.CANVAS_HEIGHT / this.STAGE_HEIGHT;

    // this.NORMAL_RESULT_TYPE = "1";
    // this.SUP_PRO_RESULT_TYPE = "2";

    // this.xSubtract = 25;
    this.xAdd = 0;
    this.yAdd = 0;

    this.heatMaxSums = [0, 0];
    this.heatmapData = [];
    this.processedHeatmapData = [];

    this.checkInvalidPoint = function (point) {
      return point[2] > this.stageWidth || point[2] < 0 || point[3] > this.stageHeight || point[3] < 0;
    };

    this.prepareHeatMapData = function () {
      const leftMax = this.heatMaxSums[0];
      const rightMax = this.heatMaxSums[1];
      let currentData;
      let currentLeftData;
      let currentRightData;
      for (let i = 0; i < this.cols; i++) {
        if (!this.heatmapData[i]) {
          continue;
        }
        for (let j = 0; j < this.rows; j++) {
          if (!this.heatmapData[i][j]) {
            continue;
          }
          currentData = this.heatmapData[i][j];
          if (leftMax !== 0) {
            currentLeftData = currentData[0] / leftMax;
          } else {
            currentLeftData = 0;
          }

          if (rightMax !== 0) {
            currentRightData = currentData[1] / rightMax;
          } else {
            currentRightData = 0;
          }

          this.processedHeatmapData.push({
            x: i,
            y: j,
            data: [currentLeftData, currentRightData],
          });
        }
      }
    };

    this.addToHeatMapSum = function (x, y, handIndex) {
      const col = Math.floor((x / this.CANVAS_WIDTH) * this.cols);
      const row = Math.floor((y / this.CANVAS_HEIGHT) * this.rows);

      if (!this.heatmapData[col]) {
        this.heatmapData[col] = [];
      }

      if (!this.heatmapData[col][row]) {
        this.heatmapData[col][row] = [0, 0];
      }

      this.heatmapData[col][row][handIndex] += 1;
      const newValue = this.heatmapData[col][row][handIndex];
      if (newValue > this.heatMaxSums[handIndex]) {
        this.heatMaxSums[handIndex] = newValue;
      }
    };

    this.drawMiddline = function (canvas) {
      const ctx = canvas.getContext('2d');
      ctx.strokeStyle = 'rgba(100, 100, 100, 0.2)';
      ctx.moveTo(canvas.width / 2, 0);
      ctx.lineTo(canvas.width / 2, canvas.height);
      ctx.stroke();
    };

    this.drawFullPath = function (canvas, path, game_id, gameType) {
      let downgradeFactorX = 1;
      let downgradeFactorY = 1;
      //If spaceship, apply resolution downgrade for handpath
      if (game_id === 4) {
        downgradeFactorX = FULL_HD_DOWNGRADE_FACTOR_X;
        downgradeFactorY = FULL_HD_DOWNGRADE_FACTOR_Y;
      }

      let multiplierX = this.xFix;
      let multiplierY = this.yFix;
      if (gameType === 1 || gameType === 2 || gameType === 3) {
        multiplierX = this.CANVAS_WIDTH;
        multiplierY = this.CANVAS_HEIGHT;
      }

      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.beginPath();

      //let legend = canvas.siblings('.handpath_legend').first();
      // legend.find('.legend_side_container').hide();
      // let canvasHeaderElement = canvas.siblings('.handpath_graph_header').first();

      //let graphTitle = graphTitles[game_name.toLowerCase()];

      //console.log("graph title: " + graphTitle);
      //canvasHeaderElement.html(graphTitle);
      /*
               if (graphTitle['tooltip']) {
                   canvasHeaderElement.parent().attr('title', graphTitle['tooltip']);
               }
             */
      //console.log(path[0]);
      let leftPath = [];
      let rightPath = [];
      let mousePath = [];
      let tubePath = [];
      let level1Path = [];
      let level2Path = [];
      // console.log(graphTitle);
      //anvas.siblings('.handpath_graph_header').first().html(graphTitle['graphTitle']);
      for (let i = 0; i < path.length; i++) {
        const tempPath = path[i];
        if (tempPath[0][0] === 'left') {
          leftPath = tempPath[1];
          if (leftPath.length > 0) {
            // legend.find('.legend_side_container.left').show();
          }
        } else if (tempPath[0][0] === 'right') {
          rightPath = tempPath[1];
          if (rightPath.length) {
            //legend.find('.legend_side_container.right').show();
          }
        } else if (tempPath[0][0] === 'mouse') {
          mousePath = tempPath[1];
          if (mousePath.length) {
            //legend.find('.legend_side_container.mouse').show();
          }
        } else if (tempPath[0][0] === 'Path') {
          tubePath = tempPath[1];
        } else if (tempPath[0][0] === 'level1') {
          //console.log('Got level1');
          level1Path = tempPath[1];

          if (level1Path.length) {
            //  legend.find('.legend_side_container.level1').show();
          }
        } else if (tempPath[0][0] === 'level2') {
          level2Path = tempPath[1];

          if (level2Path.length) {
            //  legend.find('.legend_side_container.level2').show();
          }
        }
      }

      ctx.lineWidth = 1;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.beginPath();

      //ctx.lineWidth = 8;

      this.drawMiddline(canvas);
      for (let i = 0; i < tubePath.length; i++) {
        const currentPoint = tubePath[i];

        currentPoint[2] /= downgradeFactorX;
        currentPoint[3] /= downgradeFactorY;
        const x = currentPoint[2] * multiplierX + this.xAdd;
        const y = currentPoint[3] * multiplierY + this.yAdd;
        if (this.checkInvalidPoint(currentPoint)) {
          //Nothing
        } else if (!currentPoint[0]) {
          ctx.moveTo(x, y);
        } else {
          //console.log("POINT: " + i);
          ctx.lineTo(x, y);
          ctx.strokeStyle = 'rgba(100, 100, 100, 0.5)';
        }
      }

      ctx.stroke();
      ctx.beginPath();
      ctx.lineWidth = 1;

      for (let i = 0; i < leftPath.length; i++) {
        const currentPoint = leftPath[i];
        currentPoint[2] /= downgradeFactorX;
        currentPoint[3] /= downgradeFactorY;

        const x = currentPoint[2] * multiplierX + this.xAdd;
        const y = currentPoint[3] * multiplierY + this.yAdd;

        if (this.checkInvalidPoint(currentPoint)) {
          //Nothing
        } else if (!currentPoint[0]) {
          ctx.moveTo(x, y);
        } else {
          ctx.lineTo(x, y);
          ctx.strokeStyle = 'rgb(54, 120, 147)';
          this.addToHeatMapSum(x, y, 0);
        }
      }
      ctx.stroke();
      ctx.beginPath();
      for (let i = 0; i < rightPath.length; i++) {
        const currentPoint = rightPath[i];

        currentPoint[2] /= downgradeFactorX;
        currentPoint[3] /= downgradeFactorY;

        const x = currentPoint[2] * multiplierX + this.xAdd;
        const y = currentPoint[3] * multiplierY + this.yAdd;

        if (this.checkInvalidPoint(currentPoint)) {
          //Nothing
        } else if (!currentPoint[0]) {
          ctx.moveTo(x, y);
        } else {
          ctx.lineTo(x, y);
          ctx.strokeStyle = 'rgb(182, 55, 100)';
          this.addToHeatMapSum(x, y, 1);
        }
      }

      ctx.stroke();
      ctx.beginPath();
      for (let i = 0; i < mousePath.length; i++) {
        const currentPoint = mousePath[i];

        currentPoint[2] /= downgradeFactorX;
        currentPoint[3] /= downgradeFactorY;

        if (this.checkInvalidPoint(currentPoint)) {
          //Nothing
        } else if (!currentPoint[0]) {
          ctx.moveTo(currentPoint[2] * multiplierX + this.xAdd, currentPoint[3] * multiplierY + this.yAdd);
        } else {
          ctx.lineTo(currentPoint[2] * multiplierX + this.xAdd, currentPoint[3] * multiplierY + this.yAdd);
          ctx.strokeStyle = 'rgb(214, 123, 24)';
        }
      }

      ctx.stroke();
      ctx.beginPath();
      ctx.strokeStyle = 'rgb(100, 130, 24)';
      for (let i = 0; i < level1Path.length; i++) {
        const currentPoint = level1Path[i];

        currentPoint[2] /= downgradeFactorX;
        currentPoint[3] /= downgradeFactorY;

        if (this.checkInvalidPoint(currentPoint)) {
          //Nothing
        } else if (!currentPoint[0]) {
          ctx.moveTo(currentPoint[2] * multiplierX + this.xAdd, currentPoint[3] * multiplierY + this.yAdd);
        } else {
          ctx.lineTo(currentPoint[2] * multiplierX + this.xAdd, currentPoint[3] * multiplierY + this.yAdd);
        }
      }
      ctx.stroke();
      ctx.beginPath();
      ctx.strokeStyle = 'rgb(214, 24, 200)';
      for (let i = 0; i < level2Path.length; i++) {
        const currentPoint = level2Path[i];

        currentPoint[2] /= downgradeFactorX;
        currentPoint[3] /= downgradeFactorY;

        if (this.checkInvalidPoint(currentPoint)) {
          //Nothing
        } else if (!currentPoint[0]) {
          //console.log('currentPoint x: ' + currentPoint[2]);
          //console.log('currentPoint y: ' + currentPoint[3]);
          //console.log("Moving to: (" + (currentPoint[2] * xFix - xSubtract) + ", "  + (currentPoint[3] * yFix) + ")");
          ctx.moveTo(currentPoint[2] * multiplierX + this.xAdd, currentPoint[3] * multiplierY + this.yAdd);
        } else {
          //console.log("Line to: (" + (currentPoint[2] * xFix - xSubtract) + ", "  + (currentPoint[3] * yFix) + ")");
          ctx.lineTo(currentPoint[2] * multiplierX + this.xAdd, currentPoint[3] * multiplierY + this.yAdd);
        }
      }
      ctx.stroke();

      this.prepareHeatMapData();
      return this.processedHeatmapData;
    };
  }
}

export default GraphGenerator;
